module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'l8bzmeg4',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
